import { Button, Modal } from '@metadevprofile/ui/web';
import { SmartphoneIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { getAppStoreUrl } from '@/common/hooks/use-mobile-device';

interface MobileRedirectModalProps {
  open: boolean;
}

export function MobileRedirectModal({ open }: MobileRedirectModalProps) {
  const { t } = useTranslation('practitioner');

  const handleDownloadClick = () => {
    const appStoreUrl = getAppStoreUrl();
    window.open(appStoreUrl, '_blank');
  };

  return (
    <Modal.Backdrop isOpen={open} isDismissable={false} isKeyboardDismissDisabled>
      <Modal.Container>
        <Modal.Dialog className="w-full max-h-[90vh] overflow-y-auto">
          <Modal.Header className="flex flex-row items-center space-x-4">
            <div className="flex size-16 bg-warning-soft rounded-full items-center justify-center aspect-square">
              <SmartphoneIcon className="size-8 text-warning" />
            </div>
            <div className="space-y-2 flex-1">
              <Modal.Heading className="text-xl font-bold text-foreground">{t('mobileRedirect.title')}</Modal.Heading>
              <p className="text-muted max-w-lg mx-auto">{t('mobileRedirect.description')}</p>
            </div>
          </Modal.Header>

          <Modal.Body>
            <div className="space-y-8">
              <div className="text-center space-y-6">
                <h3 className="text-xl font-semibold text-foreground">{t('mobileRedirect.downloadTitle')}</h3>

                <div className="flex justify-center">
                  <Button onPress={handleDownloadClick} className="w-full max-w-xs">
                    {t('mobileRedirect.downloadButton')}
                  </Button>
                </div>
              </div>

              <div className="bg-accent-soft border border-accent/20 rounded-lg p-6">
                <h4 className="font-semibold text-foreground mb-3">{t('mobileRedirect.instructions.title')}</h4>
                <ul className="space-y-2 text-foreground">
                  <li className="flex items-start">
                    <span className="font-bold mr-2">1.</span>
                    {t('mobileRedirect.instructions.step1')}
                  </li>
                  <li className="flex items-start">
                    <span className="font-bold mr-2">2.</span>
                    {t('mobileRedirect.instructions.step2')}
                  </li>
                  <li className="flex items-start">
                    <span className="font-bold mr-2">3.</span>
                    {t('mobileRedirect.instructions.step3')}
                  </li>
                </ul>
              </div>
            </div>
          </Modal.Body>
        </Modal.Dialog>
      </Modal.Container>
    </Modal.Backdrop>
  );
}
